/* Brainwave tabs. Without JS every panel stays visible, so nothing is lost. */
class BWTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    if (!this.tabs.length) return;
    this.tabs.forEach((t, i) => {
      t.addEventListener('click', () => this.select(i));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        this.select((i + d + this.tabs.length) % this.tabs.length, true);
      });
    });
  }
  select(i, focus) {
    this.tabs.forEach((t, n) => {
      t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      t.tabIndex = n === i ? 0 : -1;
    });
    this.panels.forEach((p, n) => { p.hidden = n !== i; });
    if (focus) this.tabs[i].focus();
  }
}
if (!customElements.get('bw-tabs')) customElements.define('bw-tabs', BWTabs);
